import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const ClosingInvoiceEditView = React.lazy(() => import('@/modules/closingInvoiceV2/closing-invoice-edit-view'))

const closingInvoiceRoutes = (
  <>
    <Route path='closinginvoice/*' element={<RedirectToPlural />} />
    <Route path='closinginvoices/new/:id?' Component={ClosingInvoiceEditView} />
    <Route path='closinginvoices/new/customerDeposit/:customerDepositId?' Component={ClosingInvoiceEditView} />
    <Route path='closinginvoices/edit/:invoiceId' Component={ClosingInvoiceEditView} />
  </>
)

export default closingInvoiceRoutes
